var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgUnblockOutline = function SvgUnblockOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.9a8.1 8.1 0 100 16.2 8.1 8.1 0 000-16.2zM2.1 12c0-5.468 4.432-9.9 9.9-9.9s9.9 4.432 9.9 9.9-4.432 9.9-9.9 9.9-9.9-4.432-9.9-9.9z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12a.9.9 0 01.9-.9h8.2a.9.9 0 010 1.8H7.9A.9.9 0 017 12z",
    fill: "#023F80"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi4wMDAxIDMuODk5OThDNy41MjY1OSAzLjg5OTk4IDMuOTAwMSA3LjUyNjQ3IDMuOTAwMSAxMkMzLjkwMDEgMTYuNDczNSA3LjUyNjU5IDIwLjEgMTIuMDAwMSAyMC4xQzE2LjQ3MzYgMjAuMSAyMC4xMDAxIDE2LjQ3MzUgMjAuMTAwMSAxMkMyMC4xMDAxIDcuNTI2NDcgMTYuNDczNiAzLjg5OTk4IDEyLjAwMDEgMy44OTk5OFpNMi4xMDAxIDEyQzIuMTAwMSA2LjUzMjM2IDYuNTMyNDggMi4wOTk5OCAxMi4wMDAxIDIuMDk5OThDMTcuNDY3NyAyLjA5OTk4IDIxLjkwMDEgNi41MzIzNiAyMS45MDAxIDEyQzIxLjkwMDEgMTcuNDY3NiAxNy40Njc3IDIxLjkgMTIuMDAwMSAyMS45QzYuNTMyNDggMjEuOSAyLjEwMDEgMTcuNDY3NiAyLjEwMDEgMTJaIiBmaWxsPSIjMDIzRjgwIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNy4wMDAwOSAxMkM3LjAwMDA5IDExLjUwMjkgNy40MDMwNCAxMS4xIDcuOTAwMDkgMTEuMUgxNi4xMDAxQzE2LjU5NzEgMTEuMSAxNy4wMDAxIDExLjUwMjkgMTcuMDAwMSAxMkMxNy4wMDAxIDEyLjQ5NyAxNi41OTcxIDEyLjkgMTYuMTAwMSAxMi45SDcuOTAwMDlDNy40MDMwNCAxMi45IDcuMDAwMDkgMTIuNDk3IDcuMDAwMDkgMTJaIiBmaWxsPSIjMDIzRjgwIi8+Cjwvc3ZnPgo=";
export { SvgUnblockOutline as ReactComponent };